<template>
    <div>
        <div class="header_search">
            <div class="topBtn">
                <Button class="item" type="primary" @click="excelCustomer">导出客户Excel</Button>
            </div>
            <div style="padding-top:10px;padding-right:5px">
                <Form :model="formItem" ref="formValidate" :label-width="80">
                    <Row>
                        <Col span="4">
                            <FormItem label="签单门店" class="mb-10" prop="sign_store_id">
                                <dropCheckBox
                                type="signStoreList"
                                :checkAllGroup="formItem.sign_store_id"
                                :checkboxData="storeList"
                                placeholder="请选择"
                                :checkedValue="signStoreCheckedShowValue"
                                @signStoreList_even="signStoreList">
                                </dropCheckBox>
                            </FormItem>
                        </Col>
                        <Col span="4">
                            <FormItem label="客户搜索" class="mb-10" prop="keyWords">
                                <Input v-model="formItem.keyWords" placeholder="请输入客户姓名/手机号"></Input>
                            </FormItem>
                        </Col>
                        <Col span="5">
                            <FormItem label="渠道部门" class="mb-10" prop="enter_department_id">
                                <Select v-model="formItem.enter_department_id" placeholder="请选择部门" @on-change="changeChannel">
                                    <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="3">
                            <FormItem :label-width="0" class="mb-10" prop="enter_channel_id">
                                <Select v-model="formItem.enter_channel_id" filterable placeholder="请选择渠道">
                                    <Option v-for="item in channel" :key="item.id" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>

                        <Col span="8" v-if="moreSearch">
                            <Col span="12">
                                <FormItem label="录入人" prop="enter_agent" class="mb-10">
                                    <Input v-model="formItem.enter_agent" placeholder="请输入录入人姓名"></Input>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="跟进门店" class="mb-10" prop="follow_store_id">
                                    <dropCheckBox
                                    type="followStoreList"
                                    :checkAllGroup="formItem.follow_store_id"
                                    :checkboxData="storeList"
                                    placeholder="请选择"
                                    :checkedValue="followStoreCheckedShowValue"
                                    @followStoreList_even="followStoreList">
                                    </dropCheckBox>
                                </FormItem>
                            </Col>
                        </Col>
                        <!-- <Col span="8" v-if="!moreSearch" class="opertionBtn">
                            <Button class="item" type="primary" @click="search" style="margin-left:5px">查询</Button>
                            <Button class="item" @click="reset">清空筛选</Button>
                            <Button class="item" type="text" style="color:#2d8cf0" @click="screening">更多筛选</Button>
                            <FormItem class="item" style="margin-bottom:0" :label-width="0">
                                <autoTableItem
                                type="vipManagement"
                                :defaultTable="defaultTable"
                                :autoTableData="autoTableData"
                                placeholder="表格展示项"
                                @autoTableRef="autoTableRef">
                                </autoTableItem>
                            </FormItem>
                        </Col> -->
                    <!-- </Row>
                    <Row v-if="moreSearch"> -->
                        <Col span="4" v-if="moreSearch">
                            <FormItem label="录入时间" class="mb-10" prop="enter_time">
                                <DatePicker v-model="formItem.enter_time" type="daterange" placeholder="请选择" style="display: block"></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="4" v-if="moreSearch">
                            <FormItem label="签单顾问" class="mb-10" prop="sign_user_store_id">
                                <Select v-model="formItem.sign_user_store_id" placeholder="请选择门店" @on-change="changeSignStore">
                                    <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="4" v-if="moreSearch">
                            <FormItem :label-width="0" class="mb-10" prop="sign_user_id">
                                <Select v-model="formItem.sign_user_id" placeholder="请选择销售部员工">
                                    <Option v-for="item in staff" :key="item.id" :value="item.id">{{item.user_name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="4" v-if="moreSearch">
                            <FormItem label="录入方式" class="mb-10" prop="insert_way_id">
                                <Select v-model="formItem.insert_way_id" multiple placeholder="请选择">
                                    <Option v-for="item in baseData.insert_way" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="4" v-if="moreSearch" style="margin-bottom:1px">
                            <FormItem label="签单日期" class="mb-10" prop="sign_time">
                                <DatePicker v-model="formItem.sign_time" type="daterange" placeholder="请选择" style="display: block"></DatePicker>
                            </FormItem>
                        </Col>
                      <Col span="4" v-if="moreSearch">
                        <FormItem label="产后客户类型"  :label-width="85" prop="chankang_type">
                          <Select v-model="formItem.chankang_type"  placeholder="请选择产后客户类型">
                            <Option v-for="item in baseData.chankang_types" :value="item.id" :key="item.id">{{item.name}}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                        <Col span="8" class="opertionBtn">
                            <Button class="item" type="text" style="color:#2d8cf0" v-if="!moreSearch" @click="screening">更多筛选</Button>
                            <Button class="item" type="text" @click="packUp" v-if="moreSearch"  style="color:#2d8cf0">收起</Button>
                            <Button class="item" type="primary" @click="search">查询</Button>
                            <Button class="item" type="primary" @click="reset">清空筛选</Button>
                            <FormItem class="item" style="margin-bottom:0" :label-width="0">
                                <autoTableItem
                                type="vipManagement"
                                :defaultTable="defaultTable"
                                :autoTableData="autoTableData"
                                placeholder="表格展示项"
                                @autoTableRef="autoTableRef">
                                </autoTableItem>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row v-if="moreSearch">
                        <Checkbox v-model="formItem.first_enter_id" style="margin-left:15px;margin-bottom:10px">仅查询首次录入时间</Checkbox>
                    </Row>
                </Form>
            </div>
        </div>
        <div style="width:100%;margin-top:10px">
            <Table ref="table" class="table_style" stripe :loading="loading" border :columns="table_columns" :data="t_data" :height="tableHeight" @on-sort-change="sortTable"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :current="formItem.page" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="changePage" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <!-- 导出客户 -->
        <customerExcel
        :excelTitle='excelTitle'
        :excelSteps="excelSteps"
        :downloadLink="downloadLink"
        :customerExcelShow="customerExcelShow"
        @customerExcelEven="customerExcelEven">
        </customerExcel>
    </div>
</template>
<script>
import dropCheckBox from "@/commonTmp/dropCheckBox"//多选下拉框
import autoTableItem from "@/commonTmp/CRM/CRM_autoTableItem"//表格自选项
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"//客户导出
export default {
    name:'vipManagement',
    components:{
        dropCheckBox,
        autoTableItem,
        customerExcel
    },
    data(){
        return{
            excelTitle:'',
            excelSteps:1,
            downloadLink:'',
            moreSearch:false,
            // downloadLoading:false,
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            signStoreCheckedShowValue:window.agent_info.store_name,
            followStoreCheckedShowValue:'',
            loading:false,
            baseData:baseData,
            customerExcelShow:false,
            formItem: {
                page:1,
                limit:50,
                sign_store_id:[window.agent_info.store_id],
                keywords: '',
                enter_agent: '',
                enter_department_id:'',
                enter_channel_id:'',
                follow_store_id: [],
                enter_time:[],
                sign_time:[],
                sign_user_store_id:'',
                sign_user_id:'',
                insert_way_id:'',
                first_enter_id:false,
              chankang_type:'',
                sort:{

                }
            },
            table_columns:[],
            defaultTable:[
                'name',
                'phone',
                'member_status',
              'chankang_type_text',
                'sign_store_list',
                'follow_store_list',
                'sign_user_list',
                'buy_package_name_list',
                'sign_time_list',
                'channel_info_list',
                'agent_name_list',
                'enter_time'
            ],
            autoTableData:[
                {
                    name: '姓名',
                    id: 'name',
                    disabled:true
                },{
                    name: '手机号',
                    id: 'phone',
                    disabled:true
                },{
                    name: '当前状态',
                    id: 'member_status',
                    disabled:true
                },
              {
                name: '产后客户类型',
                id: 'chankang_type_text',
                disabled:false
              },
              {
                    name: '签单门店',
                    id: 'sign_store_list',
                    disabled:true
                },{
                    name: '跟进门店',
                    id: 'follow_store_list'
                },{
                    name: '签单顾问',
                    id: 'sign_user_list'
                },{
                    name: '所购套餐',
                    id: 'buy_package_name_list'
                },{
                    name: '签单日期',
                    id: 'sign_time_list'
                },{
                    name: '渠道',
                    id: 'channel_info_list'
                },{
                    name: '录入人员',
                    id: 'agent_name_list'
                },{
                    name: '录入时间',
                    id: 'enter_time'
                },{
                    name: '身份证',
                    id: 'id_card'
                },{
                    name: '性别',
                    id: 'sex_text'
                },{
                    name: '所在区域',
                    id: 'region'
                },{
                    name: '详细信息',
                    id: 'address'
                },{
                    name: '备注',
                    id: 'remark'
                },{
                    name: '渠道说明',
                    id: 'channel_explain'
                },{
                    name: '录入方式',
                    id: 'insert_way'
                }
            ],
            t_columns: [
                // {
                //     type: 'selection',
                //     width: 60,
                //     align: 'center'
                // },
                {
                    title: 'ID',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: '姓名',
                    key: 'name',
                    align: 'center',
                },
                {
                    title: '手机号',
                    key: 'phone',
                    align: 'center',
                    width:140,
                        render: (h, params) => {
                            const phone = params.row.phone;
                            return h('div',[
                                h('span',{style:{textAlign: 'center'}},phone),
                                h('Button',{
                                     props: {
                                        type: 'text',
                                        icon:'ios-paper-outline'
                                    },
                                    on: {
                                        click: () => {
                                            this.copy(phone)
                                        }
                                    }
                                    }
                                )
                            ])
                        }
                },
                {
                    title: '当前状态',
                    key: 'member_status',
                    align: 'center',
                },
              {
                title: '产后客户类型',
                key: 'chankang_type_text',
                align: 'center',
                // width:180,
              },
                {
                    title: '签单门店',
                    key: 'sign_store_list',
                    align: 'center',
                    render: (h, params) => {
                        let follow_store_list = params.row.sign_store_list
                        let html=""
                        let index = 0
                        for(let item of follow_store_list){
                            if(follow_store_list.length == 1){
                                html+=item
                            }else{
                                index++
                                if(item != null){
                                    html+=index+"."+item+"\n"
                                }
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '跟进门店',
                    key: 'follow_store_list',
                    align: 'center',
                    render: (h, params) => {
                        let follow_store_list = params.row.follow_store_list
                        let html=""
                        let index = 0
                        for(let item of follow_store_list){
                            if(follow_store_list.length == 1){
                                html+=item
                            }else{
                                index++
                                if(item != null){
                                    html+=index+"."+item+"\n"
                                }
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '签单顾问',
                    key: 'sign_user_list',
                    align: 'center',
                    render: (h, params) => {
                        let sign_user_list = params.row.sign_user_list
                        let html=""
                        let index = 0
                        for(let item of sign_user_list){
                            if(sign_user_list.length == 1){
                                html+=item
                            }else{
                                index++
                                if(item != null){
                                    html+=index+"."+item+"\n"
                                }
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '所购套餐',
                    key: 'buy_package_name_list',
                    align: 'center',
                    render: (h, params) => {
                        let follow_store_list = params.row.buy_package_name_list
                        let html=""
                        let index = 0
                        for(let item of follow_store_list){
                            if(follow_store_list.length == 1){
                                html+=item
                            }else{
                                index++
                                if(item != null){
                                    html+=index+"."+item+"\n"
                                }
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '签单日期',
                    key: 'sign_time_list',
                    sortable: 'custom',
                    align: 'center',
                    render: (h, params) => {
                        let follow_store_list = params.row.sign_time_list
                        let html=""
                        let index = 0
                        for(let item of follow_store_list){
                            if(follow_store_list.length == 1){
                                html+=item
                            }else{
                                index++
                                if(item != null){
                                    html+=index+"."+item+"\n"
                                }
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '渠道',
                    key: 'channel_info_list',
                    align: 'center',
                    render: (h, params) => {
                        let channel_info_list = params.row.channel_info_list
                        let html = ''
                        let index = 0
                        for(let item of channel_info_list){
                            if(channel_info_list.length == 1){
                                html+=item
                            }else{
                                index++
                                html+=index+"."+item+"\n"
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '录入人员',
                    key: 'agent_name_list',
                    align: 'center',
                    render: (h, params) => {
                        let agent_name_list = params.row.agent_name_list
                        let html = ''
                        let index = 0
                        for(let item of agent_name_list){
                            if(agent_name_list.length == 1){
                                html+=item
                            }else{
                                index++
                                html+=index+"."+item+"\n"
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '录入时间',
                    key: 'enter_time',
                    align: 'center',
                    sortable: 'custom',
                    render: (h, params) => {
                        let enter_time = params.row.enter_time
                        let html = ''
                        let index = 0
                        for(let item of enter_time){
                            if(enter_time.length == 1){
                                html+=item
                            }else{
                                index++
                                html+=index+"."+item+"\n"
                            }
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '身份证',
                    key: 'id_card',
                    align: 'center',
                },
                {
                    title: '性别',
                    key: 'sex_text',
                    align: 'center',
                },
                {
                    title: '所在区域',
                    key: 'region',
                    align: 'center',
                },
                {
                    title: '详细地址',
                    key: 'address',
                    align: 'center',
                },
                {
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                },
                {
                    title: '渠道说明',
                    key: 'channel_explain',
                    align: 'center',
                    render: (h, params) => {
                        let channel_explain = params.row.channel_explain[0]
                        return h('div', [
                            h('div', {
                            }, channel_explain)
                        ]);
                    }
                },
                {
                    title: '录入方式',
                    key: 'insert_way',
                    align: 'center',
                    render: (h, params) => {
                        let insert_way = params.row.insert_way[0]
                        return h('div', [
                            h('div', {
                            }, insert_way)
                        ]);
                    }
                },
            ],
            t_data: [],
            pagination:{},
            storeList:[],
            departmentList:[],
            channel:[],
            staff:[],
            // selection:[]
        }
    },
    created(){
        this.apiStoreAll()
        this.apiDepartmentAll()
        this.apiVipList()
    },
    mounted() {
        console.log(window.agent_info)
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 205
    },
    methods: {
        //导出客户
        excelCustomer(){
            this.excelTitle = '导出客户Excel'
            this.excelSteps = 1
            this.customerExcelShow = true
        },
        packUp(){
            this.moreSearch=false
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 119
        },
        screening(){
            this.moreSearch=true
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 340
        },
        //获取门店列表
        apiStoreAll(){
            serve.fetchGet(api.vipMemberStore,{}).then(data => {
                console.log(data)
                this.storeList = data.data
            }).catch((error)=>{
                 if(error.response.data.status_code == 405){
                    let getCurrentStore = [
                        {
                            id:window.agent_info.store_id,
                            name:window.agent_info.store_name
                        }
                    ]
                    this.storeList = getCurrentStore
                    this.formItem.sign_store_id=[window.agent_info.store_id]
                    this.signStoreCheckedShowValue=window.agent_info.store_name
                }
                this.$Message.error(error.response.data.message);
            })
        },
        //获取部门
        apiDepartmentAll(){
            serve.fetchGet(api.vipMemberDepartment,{}).then(data => {
                console.log(data)
                 this.departmentList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //获取渠道
        apiChannelAll(id){
            serve.fetchGet(api.vipMemberChannel,{department_id:id}).then(data => {
                console.log(data)
                this.channel = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //监听选择渠道部门
        changeChannel(id){
            this.formItem.channel_id = ""
            this.channel = []
            this.apiChannelAll(id)
        },
        //获取表格数据
        apiVipList(export_title,excel_params){
            let params = {
                page:this.formItem.page,
                limit:this.formItem.limit,
                sign_store_id:this.formItem.sign_store_id,
                keywords: this.formItem.keyWords,
                enter_agent: this.formItem.enter_agent,
                enter_department_id:this.formItem.enter_department_id,
                enter_channel_id:this.formItem.enter_channel_id,
                follow_store_id: this.formItem.follow_store_id,
                enter_time_start:this.formItem.enter_time.length == 0 ? '' : util.dateFormat(this.formItem.enter_time[0]),
                enter_time_end:this.formItem.enter_time.length == 0 ? '' : util.dateFormat(this.formItem.enter_time[1]),
                sign_time_start:this.formItem.sign_time.length == 0 ? '' : util.dateFormat(this.formItem.sign_time[0]),
                sign_time_end:this.formItem.sign_time.length == 0 ? '' : util.dateFormat(this.formItem.sign_time[1]),
                sign_user_store_id:this.formItem.sign_user_store_id,
                sign_user_id:this.formItem.sign_user_id,
                insert_way_id:this.formItem.insert_way_id,
                sort:this.formItem.sort,
                chankang_type: this.formItem.chankang_type
            }
            if(this.formItem.first_enter_id){
                params.first_enter_id = 1
            }
            let url = api.getMemberVipList
            if(export_title=='导出客户Excel') {
                url = api.vipMemberExport
                this.$Message.loading({
                    content: '正在获取导出链接',
                    duration:100
                })
                if(excel_params.value == 1){
                    params.email = excel_params.mail//按筛选条件导出传参
                }else if(excel_params.value == 2){
                    params = {
                        email:excel_params.mail//按全部导出传参
                    }
                }
                params.channel_info_sort = excel_params.channel_info_sort
            }else{
                this.loading = true
            }
            serve.fetchGet(url,params).then(data => {
                console.log(data)
                //导出客户
                if(export_title=='导出客户Excel'){
                    this.$Message.destroy()
                    this.downloadLink = data.url
                    this.excelSteps = 2
                    this.customerExcelShow = true
                    return
                }
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.$Message.destroy()
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        //监听分页
        changePage(page){
            this.formItem.page = page
            this.apiVipList()
        },
        changeLimit(val){
            this.formItem.page = 1
            this.formItem.limit=val
            this.apiVipList()
        },
        //查询
        search(){
            this.formItem.page = 1
            // this.selection = []
            this.apiVipList()
        },
        //清空筛选
        reset(){
            this.$refs.formValidate.resetFields()
            this.formItem.page = 1
            this.formItem.sort = {}
            this.signStoreCheckedShowValue=window.agent_info.store_name
            this.followStoreCheckedShowValue=''
            this.formItem.sign_store_id = [window.agent_info.store_id]
              this.formItem.chankang_type = ''
            this.apiVipList()
        },
        // 复制
        copy(copyInfo){
            let oInput = document.createElement('input')
            oInput.value = copyInfo
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            oInput.style.display = 'none'
            document.body.removeChild(oInput)
            this.$Message.success('复制成功');
        },
        //监听导出客户
        //监听导出客户/回访
        customerExcelEven(val,is_export,params,title){
            this.customerExcelShow = val
            if(is_export){
                this.formItem.page = 1
                this.selection = []
                this.apiVipList(title,params)
            }
        },
        //监听签单门店
        signStoreList(data,value){
            console.log(data)
            this.formItem.sign_store_id = data
            this.signStoreCheckedShowValue = value
        },
        //监听跟进门店
        followStoreList(data,value){
            console.log(data)
            this.formItem.follow_store_id = data
            this.followStoreCheckedShowValue = value
        },
        //获取跟进人
        apiAgent(store_id,departmemt_id){
            let params = {
                store_id:store_id,
                departmemt_id:departmemt_id
            }
            serve.fetchGet(api.vipMemberAgent,params).then(data => {
                console.log(data)
                this.staff = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //监听签单门店
        changeSignStore(store_id){
            this.formItem.sign_user_id = ''
            this.staff = []
            let getDepartment_id = ''
            for(let item of this.storeList){
                if(store_id == item.id){
                    getDepartment_id = item.departmemt_id+''
                }
            }
            this.apiAgent(store_id,getDepartment_id)
        },
        //表格排序
        sortTable(column){
            console.log(column)
            if(column.order!='normal'){
                switch(column.column.title){
                    case '签单日期':
                        this.formItem.sort.sort=column.order
                        this.formItem.sort.field='member_vips_sign_time'
                    break;
                    case '录入时间':
                        this.formItem.sort.sort=column.order
                        this.formItem.sort.field='channel_infos_created_at'
                    break
                }
                this.apiVipList()
            }
        },
        //监听表格自选
        autoTableRef(data){
            let getTableHead = [this.t_columns[0]]
            for(let item of data){
                switch(item) {
                    case "name":
                        getTableHead.push(this.t_columns[1])
                        break;
                    case "phone":
                        getTableHead.push(this.t_columns[2])
                        break;
                    case "member_status":
                        getTableHead.push(this.t_columns[3])
                        break;
                    case "chankang_type_text":
                        getTableHead.push(this.t_columns[4])
                        break;
                    case "sign_store_list":
                        getTableHead.push(this.t_columns[5])
                        break;
                    case "follow_store_list":
                        getTableHead.push(this.t_columns[6])
                        break;
                    case "sign_user_list":
                        getTableHead.push(this.t_columns[7])
                        break;
                    case "buy_package_name_list":
                        getTableHead.push(this.t_columns[8])
                        break;
                    case "sign_time_list":
                        getTableHead.push(this.t_columns[9])
                        break;
                    case "channel_info_list":
                        getTableHead.push(this.t_columns[10])
                        break;
                    case "agent_name_list":
                        getTableHead.push(this.t_columns[11])
                        break;
                    case "enter_time":
                        getTableHead.push(this.t_columns[12])
                        break;
                     case "id_card":
                        getTableHead.push(this.t_columns[13])
                        break;
                    case "sex_text":
                        getTableHead.push(this.t_columns[14])
                        break;
                    case "region":
                        getTableHead.push(this.t_columns[15])
                        break;
                    case "address":
                        getTableHead.push(this.t_columns[16])
                        break;
                    case "remark":
                        getTableHead.push(this.t_columns[17])
                        break;
                    case "channel_explain":
                        getTableHead.push(this.t_columns[18])
                        break;
                    case "insert_way":
                        getTableHead.push(this.t_columns[19])
                        break;

                }
            }
            this.table_columns = getTableHead
        }
    }
}
</script>
<style lang="" scope>
    .page{
        display: flex;
        justify-content: flex-end;
    }
    .demo-drawer-footer{
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
    .mb-10{
        margin-bottom: 10px
    }
    .opertionBtn{
        margin-bottom:20px;
        display:flex!important;
        display: -webkit-flex!important;
        align-items: center
    }
    .opertionBtn .item{
        margin-right: 5px
    }
    .topBtn{
        display:flex;
        justify-content: flex-end;
        padding-bottom:10px;
        border-bottom:1px solid #e8eaec;
        padding-top:10px;
        padding-right:5px;
        background: rgba(249,249,249)
    }
    .topBtn .item{
        margin-left: 5px;
    }
    .opertionBtn_search .item{
        margin-right: 5px;
    }
    .header_search{
        border:1px solid #e8eaec
    }
    .table_style .ivu-table-cell{
        padding-left:2px;
        padding-right:2px
    }
</style>



// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/vipManagement.vue